import script from "./WeldingTab.vue?vue&type=script&setup=true&lang=js"
export * from "./WeldingTab.vue?vue&type=script&setup=true&lang=js"

import "./WeldingTab.vue?vue&type=style&index=0&id=402fad8d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-402fad8d"]])

export default __exports__